import { messagesLoaders } from '../../localized-messages';
import { LocalizedMessageLanguage } from '../types';

export const availableLanguages = Object.keys(messagesLoaders) as LocalizedMessageLanguage[];

const getPrimaryLanguageSubtag = (languageTag: string) => languageTag.split('-')[0];

export const DEFAULT_LOCALE = 'en-US';

export const DEFAULT_LANGUAGE = getPrimaryLanguageSubtag(
  DEFAULT_LOCALE,
) as LocalizedMessageLanguage;

export const availableLocales = [
  'az',
  'cs',
  'da',
  'de',
  'el',
  'en-GB',
  'en-US',
  'en',
  'es',
  'et',
  'fi',
  'fr',
  'he',
  'hr',
  'hu',
  'ja',
  'ka',
  'kk',
  'lt',
  'lv',
  'mt',
  'nb',
  'nn',
  'ro',
  'ru',
  'sk',
  'sl',
  'sr',
  'sv',
  'th',
  'tr',
] as const;

export function getUserLanguage() {
  const language = window.navigator.language;
  const languageSubtag = getPrimaryLanguageSubtag(language) as LocalizedMessageLanguage;
  if (availableLanguages.includes(languageSubtag)) {
    return languageSubtag;
  }
  return DEFAULT_LANGUAGE;
}

export function getUserLocale() {
  const language = window.navigator.language;
  if ((availableLocales as ReadonlyArray<string>).includes(language)) {
    return language;
  }
  return DEFAULT_LOCALE;
}

export function getLanguageName(locale: string, language: string) {
  return new Intl.DisplayNames([locale], { type: 'language', style: 'short' }).of(language);
}

/**
 * Get language name in both English and local language.
 */
export function getFullLanguageName(language: string) {
  const englishName = getLanguageName('en', language);
  const localName = getLanguageName(language, language);
  return englishName !== localName ? `${englishName} - ${localName}` : (englishName ?? language);
}
